import classes from "./Footer.module.css";
const Footer = (props) => {
  return (
    <div className={classes.footer}>
      <p>© All rights reserved. Amra 2023</p>
    </div>
  );
};

export default Footer;
